










import Vue from 'vue';
import NavBar from '@/components/shared/NavBar.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'BaseLayout',
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    hideNavbar(this: any) {
      return this.$route.meta?.hideNavbar;
    }
  },
  components: {
    NavBar,
    LoadingSpinner
  }
});
